import React, { useState, useRef }
from 'react';
import '../../stylesheets/Login.css';
import { selectAllStrings }
from '../language/languageSlice';
import { useSelector, useDispatch }
from 'react-redux';
import { Link }
from 'react-router-dom';
import { login }
from './userSlice';
import { unwrapResult }
from '@reduxjs/toolkit';
import { useHistory }
from 'react-router';
import ErrorMessage from '../../app/ErrorMessage';
import { getUdid }
from '../../api/mobile';
import { logEvent, EVENTS }
from '../../lib/event-helper';
import constants from '../../constants';
import PurchaseButton from '../../components/PurchaseButton';


const LoginPage = () => {
    const strings = useSelector(selectAllStrings);
    const [cardNumber, setCardNumber] = useState('');
    const [password, setPassword] = useState('');
    const [agree, setAgree] = useState(false);
    const [loginRequestStatus, setLoginRequestStatus] = useState('idle');
    const [error, setError] = useState('');
    const dispatch = useDispatch();
    const onCardNumberChanged = (event) => {
        setCardNumber(event.target.value);
    };
    const onPasswordChanged = (event) => {
        setPassword(event.target.value);
    };
    const onAgreeChanged = (event) => setAgree(event.target.checked);
    const canLogin = cardNumber && password && (agree || constants.environment 
            == 'iOS') && loginRequestStatus === 'idle';
    const history = useHistory();
    const passwordRef = useRef(null);
    const toggleShowPassword = (event) => {

        event.preventDefault();
        event.stopPropagation();
        passwordRef.current.type = passwordRef.current.type == 'password' ? 'text' : 'password';
        event.target.className = event.target.className ==
                'toggle-show-password' ? 'toggle-show-password hide' :
                'toggle-show-password';
    };
    const onLoginClicked = async (event) => {
        event.preventDefault();
        if (canLogin) {
            try {
                setLoginRequestStatus('pending');
                const udid = await getUdid();
                const resultAction = await dispatch(
                        login({udid, cardNumber, password})
                        );
                unwrapResult(resultAction);
                if ((resultAction.payload.trial && resultAction.payload.trial.status == 1) ||
                        resultAction.payload.pay_user && resultAction.payload.pay_user.status == 1) {

                    let profileId = resultAction.payload.pay_user.profile_id;
                    logEvent(EVENTS.LOGIN_OK, profileId);
                    history.push('/home');
                } else {
                    let user = resultAction.payload.trial || resultAction.payload.pay_user;
                    setError(user.msg);
                    setLoginRequestStatus('idle');
                }
            } catch (err) {
                setError(err.message);
                setLoginRequestStatus('idle');
            }
        }
    };
    return <div id="login_page">
        {error.length > 0 ? <ErrorMessage strings={strings} message={error} onGoBack={() => setError('')}/> :
                    <div>
                
                        <Link className="go-back" to={'/'} ></Link>
                        <h1>{strings.login_to_your_account}</h1>
                        <p>{constants.environment == 'iOS' ? null : strings.enter_valid_card}</p>
                        <form>
                
                            <input type="text" id="card_number" placeholder={strings.card_number_placeholder} required value={cardNumber} onChange={onCardNumberChanged}/>
                            <label className="password-label">
                                <input type="password" id="password" placeholder={strings.password} required value={password} onChange={onPasswordChanged} ref={passwordRef}/>
                                <span className="toggle-show-password" onClick={toggleShowPassword}></span>
                            </label>
                            {constants.environment == 'iOS' ? null :
                                        <React.Fragment>
                                            <span id="forgot_password">{strings.password} <a href="https://account.pleinairclub.it/?page_id=23&action=forgot_password" target="_blank">{strings.forgot}</a>?</span>
                            
                                            <input type="checkbox" id="agree_checkbox" required className="custom-checkbox" checked={agree} onChange={onAgreeChanged}/> <label htmlFor="agree_checkbox" id="agree">
                                                <span id="agree_label">{strings.you_agree_to}  <a href="https://www.pleinairclub.it/privacy-app" target="_blank">{strings.terms_and_conditions}</a> {strings.of_planairclub}</span>
                                            </label>
                                        </React.Fragment>}
                
                
                            <button className="btn" type="submit" id="login_button" onClick={onLoginClicked}>
                                {loginRequestStatus === 'pending' ? <div className="loader"></div> : strings.login}
                            </button>
                            {constants.environment == 'iOS' ?
                                        <PurchaseButton/>
                                            :
                                        <div id="registration">{strings.not_registered_yet}
                                            <a href="https://account.pleinairclub.it/?page_id=23&c=1#panel-account" target="_blank"> {strings.register_now}</a>
                                        </div>}
                        </form>
                    </div>}
    
    </div>
};



export default LoginPage;